(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos-final"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.querySelector(".ugc-videos__modal");
    var modalVideo = modal && modal.querySelector(".ugc-videos__modal-video");
    var closeBtn = modal && modal.querySelector(".ugc-videos__modal-close");
    if (!modal || !modalVideo) return;

    // Force play inline videos when visible (fixes mobile autoplay block)
    var cards = document.querySelectorAll(".ugc-videos__card");
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector("video");
          if (!v) return;
          if (entry.isIntersecting) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      cards.forEach(function (card) { observer.observe(card); });
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        var url = card.dataset.videoUrl;
        if (!url) return;
        modalVideo.src = url;
        modal.showModal();
        modalVideo.play();
      });
    });

    function closeModal() {
      modalVideo.pause();
      modalVideo.src = "";
      modal.close();
    }

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
    modal.addEventListener("cancel", function () { modalVideo.pause(); modalVideo.src = ""; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    

  (function () {

    var modal = document.querySelector(".ugc-videos__modal");

    if (!modal) return;

    var feed = modal.querySelector(".ugc-videos__feed");

    var slides = modal.querySelectorAll(".ugc-videos__slide");

    var closeBtn = modal.querySelector(".ugc-videos__modal-close");

    var muteBtn = modal.querySelector(".ugc-videos__mute-btn");

    var playBtn = modal.querySelector(".ugc-videos__play-btn");

    var progressBar = modal.querySelector(".ugc-videos__progress");

    var progressFill = modal.querySelector(".ugc-videos__progress-fill");

    var volumeSlider = modal.querySelector(".ugc-videos__volume-slider");

    var ctaBtn = modal.querySelector(".ugc-videos__cta");

    var cards = document.querySelectorAll(".ugc-videos__card");



    // Default: muted on open (avoid annoying users). User can toggle.

    var userMuted = false;

    var userVolume = 1; // 0..1

    var activeVideo = null;

    var ctaTimer = null;



    var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';

    var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';



    function onTimeUpdate() {

      if (!activeVideo || !activeVideo.duration || !progressFill) return;

      var pct = (activeVideo.currentTime / activeVideo.duration) * 100;

      progressFill.style.width = pct + "%";

    }

    function updatePlayBtn() {

      if (!playBtn) return;

      var paused = !activeVideo || activeVideo.paused;

      playBtn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;

    }

    function setActiveVideo(v) {

      if (activeVideo === v) return;

      if (activeVideo) {

        activeVideo.removeEventListener("timeupdate", onTimeUpdate);

        activeVideo.removeEventListener("play", updatePlayBtn);

        activeVideo.removeEventListener("pause", updatePlayBtn);

      }

      // Pause all other slide videos to guarantee single audio track at any time

      modal.querySelectorAll(".ugc-videos__slide-video").forEach(function (other) {

        if (other !== v) other.pause();

      });

      activeVideo = v;

      if (progressFill) progressFill.style.width = "0%";

      if (v) {

        try { v.currentTime = 0; } catch (e) {}

        v.addEventListener("timeupdate", onTimeUpdate);

        v.addEventListener("play", updatePlayBtn);

        v.addEventListener("pause", updatePlayBtn);

      }

      updatePlayBtn();

    }



    function applyMuteState(v) {

      v.muted = userMuted;

      v.volume = userVolume;

    }



    function pauseAllSlideVideos() {

      modal.querySelectorAll(".ugc-videos__slide-video").forEach(function (v) {

        v.pause();

      });

    }



    function tryPlay(v) {

      if (!v) return;

      applyMuteState(v);

      v.play().catch(function () {

        // Autoplay with sound rejected — mute and play, then try to restore sound.

        v.muted = true;

        v.play().then(function () {

          // Video now playing muted. If user wants sound, attempt unmute

          // (often allowed post-play due to priming + sticky activation).

          if (!userMuted) {

            v.muted = false;

            // If browser silently re-mutes, sync icon to match reality after a tick

            setTimeout(function () {

              if (v === activeVideo && v.muted && !userMuted) {

                userMuted = true;

                updateMuteBtn();

              }

            }, 50);

          }

        }).catch(function () {});

      });

    }



    function showCtaDelayed() {

      if (!ctaBtn) return;

      ctaBtn.classList.remove("is-visible");

      if (ctaTimer) clearTimeout(ctaTimer);

      ctaTimer = setTimeout(function () {

        ctaBtn.classList.add("is-visible");

      }, 2500);

    }



    // Prime ONE video within user-gesture context (modal open / swipe).

    // iOS Safari needs each video "unlocked" by user-initiated play() before

    // later programmatic unmuted play() works. Play muted → pause = silent unlock.

    // Lazy approach (only neighbors) keeps mobile data low — non-primed videos

    // stay at preload="metadata" so they don't fetch full bytes until reached.

    function primeVideo(v) {

      if (!v || v.dataset.primed === "1") return;

      v.dataset.primed = "1";

      v.muted = true;

      var p = v.play();

      if (p && p.then) {

        p.then(function () { v.pause(); v.currentTime = 0; }).catch(function () {

          delete v.dataset.primed;

        });

      }

    }



    function primeNeighbors(index) {

      [index - 1, index + 1].forEach(function (i) {

        if (slides[i]) primeVideo(slides[i].querySelector(".ugc-videos__slide-video"));

      });

    }



    function openAt(index) {

      modal.showModal();

      showCtaDelayed();

      var firstVideo = slides[index] ? slides[index].querySelector(".ugc-videos__slide-video") : null;

      // Mark first as primed (it'll play immediately, no need to prime)

      if (firstVideo) firstVideo.dataset.primed = "1";

      primeNeighbors(index);

      requestAnimationFrame(function () {

        if (slides[index]) {

          slides[index].scrollIntoView({ behavior: "instant", block: "start" });

          if (firstVideo) {

            setActiveVideo(firstVideo);

            tryPlay(firstVideo);

          }

        }

      });

    }



    // Slide play/pause based on visibility in modal feed

    if ("IntersectionObserver" in window && feed) {

      var slideObs = new IntersectionObserver(function (entries) {

        entries.forEach(function (entry) {

          var v = entry.target.querySelector(".ugc-videos__slide-video");

          if (!v) return;

          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {

            // Only act when this is a NEW active video — prevents currentTime reset

            // when scroll-snap oscillates around the threshold.

            if (activeVideo !== v) {

              setActiveVideo(v);

              tryPlay(v);

              // Prime the next neighbor so subsequent swipe is smooth + unlocked

              var idx = parseInt(entry.target.dataset.index || "0", 10);

              primeNeighbors(idx);

            } else if (v.paused) {

              // Same video, but got paused — resume without resetting currentTime

              applyMuteState(v);

              v.play().catch(function () {});

            }

          } else if (activeVideo !== v) {

            // Only pause non-active videos when they leave viewport.

            // Active video stays playing through brief threshold dips during scroll.

            v.pause();

          }

        });

      }, { threshold: [0, 0.6, 1], root: feed });

      slides.forEach(function (s) { slideObs.observe(s); });

    }



    // Tap anywhere on slide to toggle play/pause

    slides.forEach(function (s) {

      s.addEventListener("click", function (e) {

        // Ignore clicks on hint/counter (already pointer-events:none, but be safe)

        if (e.target.closest(".ugc-videos__slide-counter, .ugc-videos__slide-swipe-hint")) return;

        var v = s.querySelector(".ugc-videos__slide-video");

        if (!v) return;

        if (v.paused) {

          tryPlay(v);

        } else {

          v.pause();

        }

      });

    });



    // Play/pause button toggle

    if (playBtn) {

      playBtn.addEventListener("click", function (e) {

        e.stopPropagation();

        if (!activeVideo) return;

        if (activeVideo.paused) {

          tryPlay(activeVideo);

        } else {

          activeVideo.pause();

        }

      });

      updatePlayBtn();

    }



    // Progress bar seek

    if (progressBar) {

      progressBar.addEventListener("click", function (e) {

        e.stopPropagation();

        if (!activeVideo || !activeVideo.duration) return;

        var rect = progressBar.getBoundingClientRect();

        var pct = (e.clientX - rect.left) / rect.width;

        pct = Math.max(0, Math.min(1, pct));

        try { activeVideo.currentTime = pct * activeVideo.duration; } catch (err) {}

      });

    }



    cards.forEach(function (card) {

      card.addEventListener("click", function () {

        var i = parseInt(card.dataset.index || "0", 10);

        openAt(i);

      });

    });



    function closeModal() {

      pauseAllSlideVideos();

      setActiveVideo(null);

      if (progressFill) progressFill.style.width = "0%";

      if (ctaTimer) { clearTimeout(ctaTimer); ctaTimer = null; }

      if (ctaBtn) ctaBtn.classList.remove("is-visible");

      modal.close();

    }



    closeBtn && closeBtn.addEventListener("click", function (e) { e.stopPropagation(); closeModal(); });

    modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });

    modal.addEventListener("cancel", function (e) { e.preventDefault(); closeModal(); });



    // Mute toggle

    function updateMuteBtn() {

      if (!muteBtn) return;

      muteBtn.innerHTML = userMuted

        ? '<svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>'

        : '<svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';

    }

    if (muteBtn) {

      muteBtn.addEventListener("click", function (e) {

        e.stopPropagation();

        userMuted = !userMuted;

        // If unmuting and volume was 0, restore to full

        if (!userMuted && userVolume === 0) {

          userVolume = 1;

          if (volumeSlider) volumeSlider.value = 100;

        }

        // Apply mute state to ALL videos (so when user scrolls, next slide has correct state)

        // but only PLAY the active one (avoid multiple audio tracks playing simultaneously)

        modal.querySelectorAll(".ugc-videos__slide-video").forEach(function (v) {

          applyMuteState(v);

        });

        if (!userMuted && activeVideo) activeVideo.play().catch(function () {});

        updateMuteBtn();

      });

      updateMuteBtn();

    }



    // Volume slider (Meta Reels style)

    if (volumeSlider) {

      volumeSlider.addEventListener("click", function (e) { e.stopPropagation(); });

      volumeSlider.addEventListener("input", function () {

        userVolume = parseInt(volumeSlider.value, 10) / 100;

        userMuted = userVolume === 0;

        modal.querySelectorAll(".ugc-videos__slide-video").forEach(function (v) {

          applyMuteState(v);

        });

        if (!userMuted && activeVideo) activeVideo.play().catch(function () {});

        updateMuteBtn();

      });

    }



    // CTA: close modal + scroll to ATC

    if (ctaBtn) {

      ctaBtn.addEventListener("click", function (e) {

        e.stopPropagation();

        var sel = ctaBtn.getAttribute("data-cta-target") || 'button[name="add"]';

        closeModal();

        setTimeout(function () {

          var target = document.querySelector(sel);

          if (target) {

            // Zero-height targets are anchors sitting on top of the product grid,
            // so align them to the top and let their scroll-margin do the work.
            // "center" parked the grid halfway down the screen. A real element
            // (the add-to-cart button on product pages) still centres.

            var align = target.getBoundingClientRect().height < 4 ? "start" : "center";

            target.scrollIntoView({ behavior: "smooth", block: align });

          }

        }, 150);

      });

    }



    // Pull-down-to-close (TikTok pattern) on first slide

    if (feed) {

      var touchStartY = 0;

      var touchActive = false;

      feed.addEventListener("touchstart", function (e) {

        if (feed.scrollTop <= 0) {

          touchStartY = e.touches[0].clientY;

          touchActive = true;

        }

      }, { passive: true });

      feed.addEventListener("touchmove", function (e) {

        if (!touchActive) return;

        var deltaY = e.touches[0].clientY - touchStartY;

        if (deltaY > 80 && feed.scrollTop <= 0) {

          touchActive = false;

          closeModal();

        }

      }, { passive: true });

      feed.addEventListener("touchend", function () { touchActive = false; }, { passive: true });

    }

  })();

  // Sequential spotlight for the grid: exactly ONE inline video plays at a time
  // (muted); the other cards hold their poster, slightly dimmed. Each video plays
  // to the END, then the spotlight moves to the next card. A 60s watchdog advances
  // past a stalled video so the rotation can never get stuck. Pauses entirely when
  // the grid leaves the viewport or the sound modal opens. Skipped for reduced motion.
  (function () {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var grids = document.querySelectorAll(".ugc-videos__grid");
    grids.forEach(function (grid) {
      var vids = Array.prototype.slice.call(grid.querySelectorAll("video[data-ugc-spotlight]"));
      if (!vids.length) return;
      var cards = vids.map(function (v) { return v.closest(".ugc-videos__card"); });
      var current = 0;
      var running = false;
      var watchdog = null;
      var gridVisible = false;
      var modal = document.querySelector(".ugc-videos__modal");

      function clearWatchdog() {
        if (watchdog) { clearTimeout(watchdog); watchdog = null; }
      }
      function advance() {
        if (!running) return;
        spotlight((current + 1) % vids.length);
      }
      function spotlight(i) {
        current = i;
        clearWatchdog();
        vids.forEach(function (v, j) {
          if (!cards[j]) return;
          if (j === i) {
            cards[j].classList.add("is-live");
            cards[j].classList.remove("is-dim");
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            cards[j].classList.remove("is-live");
            cards[j].classList.add("is-dim");
            v.pause();
          }
        });
        watchdog = setTimeout(advance, 60000);
      }
      vids.forEach(function (v, j) {
        v.addEventListener("ended", function () {
          if (running && j === current) advance();
        });
      });
      function start() {
        if (running) return;
        running = true;
        spotlight(current);
      }
      function stop() {
        running = false;
        clearWatchdog();
        vids.forEach(function (v) { v.pause(); });
        cards.forEach(function (c) { c && c.classList.remove("is-live", "is-dim"); });
      }
      function sync() {
        var modalOpen = modal && modal.hasAttribute("open");
        if (gridVisible && !modalOpen) { start(); } else { stop(); }
      }

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            gridVisible = e.isIntersecting && e.intersectionRatio > 0.35;
            sync();
          });
        }, { threshold: [0, 0.35] }).observe(grid);
      } else {
        gridVisible = true;
        sync();
      }
      if (modal && "MutationObserver" in window) {
        new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ["open"] });
      }
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
